module.exports = __webpack_public_path__ + "static/media/ebisu.f53bce49.png";